define(function (require) {
    "use strict";

    var LE = require("app");
    var template = require("user-management-templates/profiles/profilesGridRowView.tmpl");
    var Loader = require("ui/loader/Loader");
    var PlusCompositeView = require("ui/plus-composite-view/PlusCompositeView");

    var Checkbox = require("ui/checkbox/Checkbox");

    var ROLES = require("user-management-assets/data/roles.json");

    var ProfilesGridRowView = {};

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {

        ProfilesGridRowView = Marionette.ItemView.extend({
            tagName: "tr",
            className: "profile-row",
            template: template,
            ui: {
                selector: ".selector",
                profileName: ".profile-name",
                role: ".role",
                description: ".description",
                usersNum: ".usersNum"
            },
            uiComponents: {
                selectorCheckbox: {
                    type: Checkbox,
                    options: {
                        el: "view.ui.selector",
                        checked: false,
                        label: "",
                        permutation: Checkbox.PERMUTATION.B // no label
                    },
                    events: {
                        "change": "_onSelectorChange"
                    }
                }
            },
            events: {
                "click @ui.selector": "_onSelectorWrapperClick",
                "click @ui.profileName": "_onRowClick",
                "click @ui.role": "_onRowClick",
                "click @ui.description": "_onRowClick",
                "click @ui.usersNum": "_onRowClick"
            },

            customTemplateHelpers: function () {
                var profileName = this.model.getName();
                var role = this.model.getRoleTypeId();
                var description = this.model.getDescription();
                var usersNum = this.model.getNumOfAssingnedUsers() || 0;

                return {
                    profileName: profileName,
                    role: LE.translator.translate(ROLES[role]),
                    description: description,
                    usersNum: usersNum
                };
            },

            initialize: function (options) {
                LEUserManagement.logger.debug("initialize", "ProfilesGridRowView:initialize");
                this.loaders = [];
                this.channel = LEUserManagement.media.channel(LEUserManagement.channels.PROFILE_LIST);
                this._bindEvents();
            },

            onRender: function () {
                LEUserManagement.logger.debug("onRender", "ProfilesGridRowView:onRender");
            },
            onClose: function () {
                LEUserManagement.logger.debug("onClose", "ProfilesGridRowView:onClose");
            },

            _bindEvents: function (checked) {
                LEUserManagement.logger.debug("_bindEvents", "ProfilesGridRowView:_bindEvents");
                this.listenTo(this.model, "model:selection:change", this._onModelSelectionChange);
            },

            _onSelectorWrapperClick: function (e) {
                LEUserManagement.logger.debug("_onSelectorWrapperClick", "ProfilesGridRowView:_onSelectorWrapperClick");
                if ($(e.target).hasClass("selector")) {
                    this.uiComponents.selectorCheckbox.checkboxClick();
                }
            },

            _onRowClick: function () {
                LEUserManagement.logger.debug("_onRowClick", "ProfilesGridRowView:_onRowClick");
                this.channel.trigger("row:click", this.model);
            },

            _onSelectorChange: function (componentId, eventName, isChecked) {
                LEUserManagement.logger.debug("_onSelectorChange", "ProfilesGridRowView:_onSelectorChange");
                this.channel.trigger("row:selector:click", {itemModel: this.model, isChecked: isChecked});
            },

            _onModelSelectionChange: function (isChecked) {
                LEUserManagement.logger.debug("_onModelSelectionChange", "ProfilesGridRowView:_onModelSelectionChange");
                this.$el.toggleClass("selected", isChecked);
                this.uiComponents.selectorCheckbox.setCheckedState(isChecked);
            }
        });
    }

    LE.module("LEUserManagement", moduleDefinition);

    return ProfilesGridRowView;
});
